import React, { useState } from 'react'
import { Button } from 'react-bootstrap'





export default function CustomButton({ buttonName, onClick, type, loadingMessage, isLoading, style, iconClassName, needIcon, className = false }) {


    return (

        <Button
            onClick={onClick}
            variant="primary"
            type={type}
            disabled={isLoading}
            style={{ ...style, borderRadius: '0px',display:'flex',justifyContent:'center',alignItems:'center' }}
            className={className}
        >
            <div className='d-flex'>

              
                    {isLoading ? loadingMessage : buttonName} &nbsp;&nbsp;
              
                    {needIcon && <i className={iconClassName}></i>}
            </div>


        </Button>



    )
}

